import React from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'  
import ModalCloseButton from 'components/buttons/ModalCloseButton'
import { MdComputer } from "react-icons/md";
import { IoIosLink } from "react-icons/io";  
import { PiFileAudio } from "react-icons/pi";
import {setViewUploadAudioModal, setSelectedAudioSource} from 'features/audio/audioSlice'
import { UploadModalContainer, StyledHeading, MediaTitle } from 'components/media/media.styled';
import { useTranslation } from 'react-i18next'

export default function SourceSelect({handler1, handler2, mediaType}) {
    const { t } = useTranslation('media')

    const dispatch = useDispatch() 

    const handleCloseModal = () => {
        dispatch(setSelectedAudioSource(null)) 
        dispatch(setViewUploadAudioModal( false ))
    }

    return (
        <UploadModalContainer>
            <ModalCloseButton
                handler={handleCloseModal}
                top={'20px'}
                right={'20px'}
                size='30px'
                />


                <StyledHeading>
                    <PiFileAudio size={24} /> 
                    <span>{t('audioUpload')}</span>
                </StyledHeading>

            <MediaTitle>{t('selectAudioSource')}</MediaTitle>
            <CCC>
                <FItem 
                    onClick={handler1}
                    >
                    <MdComputer />
                    <span>{t('onDevice')}</span>
                </FItem>
                <FItem onClick={ handler2 }
                    >
                    <IoIosLink />
                    <span>{t('onWeb')}</span>
                </FItem>
            </CCC>

        </UploadModalContainer>
    )
}

const FItem = styled.div`
    width: 50%;
    height: 200px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
    transition: 0.3s;
    cursor: pointer;
    color: var(--lightThemeFontColor);
    &:hover{
        background: #f5f5f5;
        border-radius: 5px;

        p{
            display: flex;
        }

    }
    svg{
        font-size: 30px;
        margin-bottom: 10px;
        color: var(--lightThemeFontColor);
    }

    p{
        display: none;
        font-style: italic;
        position: absolute;
        bottom: 0;
        font-size: small;
        color: var(--lightThemeFontColor);
    }

`

const CCC = styled.div`
    margin-top: 20px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    transition: 0.3s;
    cursor: pointer;
    color: var(--lightThemeFontColor);

`
